import { httpClient } from '@/shared/api/client.ts'

export function logout() {
  return httpClient.post('member/logout').json()
}
